import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const DefaultSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "DefaultSettingsPage" */ "@circle-react/components/SettingsApp/DefaultPage"
    ),
);

export const DefaultSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <DefaultSettingsComponent />
  </Suspense>
);
